/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { CustomPopover } from '../../../cs/common/components/custom-popover';
import { IWWCharacter } from '../../../common/model/graphql-types';
import { WWCharacterPopover } from './ww-character-popover';
import {
  faAnglesUp,
  faArrowDown,
  faArrowUp,
  faEye
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
  employee: IWWCharacter;
  enablePopover?: boolean;
  showLabel?: boolean;
  showIcon?: boolean;
  showEidolon?: boolean;
  showTierListchange?: boolean;
  tags?: string;
  tier?: string;
}

export const WWCharacterIcon: React.FC<IProps> = ({
  employee,
  showLabel,
  enablePopover,
  showEidolon,
  showTierListchange,
  tags,
  tier
}) => {
  const image = employee.smallImage
    ? getImage(employee.smallImage.localFile.childImageSharp)
    : null;
  return (
    <CustomPopover
      enabled={enablePopover}
      customClass="character-hover-box ww"
      popover={<WWCharacterPopover character={employee} />}
    >
      <Link to={'/wuthering-waves/characters/' + employee.slug}>
        <div
          className={`avatar ww rarity-${employee.rarity} ${
            showLabel ? showLabel : ''
          }`}
        >
          {image && (
            <GatsbyImage
              className="disable-transition"
              image={image}
              alt={`${employee.name}`}
            />
          )}
          {showEidolon && (
            <span
              className={`floating-element sequence ${
                employee.rarity === '4' ? 'rar-4' : 'rar-5'
              } `}
            >
              {employee.rarity === '4' ? (
                <>S6</>
              ) : (
                <>
                  {employee.slug === 'rover-spectro' && 'S6'}
                  {employee.slug === 'rover-aero' && 'S1'}
                  {employee.slug === 'rover-havoc' && 'S6'}
                  {employee.slug != 'rover-spectro' &&
                    employee.slug != 'rover-havoc' &&
                    employee.slug != 'rover-aero' &&
                    'S0R0'}
                </>
              )}
            </span>
          )}
          {showTierListchange && tier === 'toa' && (
            <>
              {showEidolon && employee.slug === 'calcharo' && (
                <span className={`floating-element expert`}>
                  <FontAwesomeIcon icon={faAnglesUp} width="18" />
                </span>
              )}
              {showEidolon && employee.slug === 'yangyang' && (
                <span className={`floating-element expert`}>
                  <FontAwesomeIcon icon={faAnglesUp} width="18" />
                </span>
              )}
              {showEidolon && employee.slug === 'changli' && (
                <span className={`floating-element expert`}>
                  <FontAwesomeIcon icon={faAnglesUp} width="18" />
                </span>
              )}
              {showEidolon && employee.slug === 'danjin' && (
                <span className={`floating-element expert`}>
                  <FontAwesomeIcon icon={faAnglesUp} width="18" />
                </span>
              )}
              {showEidolon && employee.slug === 'jiyan' && (
                <span className={`floating-element expert`}>
                  <FontAwesomeIcon icon={faAnglesUp} width="18" />
                </span>
              )}
              {showEidolon && employee.slug === 'encore' && (
                <span className={`floating-element expert`}>
                  <FontAwesomeIcon icon={faAnglesUp} width="18" />
                </span>
              )}
            </>
          )}
          {showTierListchange && tier === 'ww' && (
            <>
              {showEidolon && employee.slug === 'calcharo' && (
                <span className={`floating-element expert`}>
                  <FontAwesomeIcon icon={faAnglesUp} width="18" />
                </span>
              )}
              {showEidolon && employee.slug === 'phoebe' && (
                <span className={`floating-element expert`}>
                  <FontAwesomeIcon icon={faAnglesUp} width="18" />
                </span>
              )}
              {showEidolon && employee.slug === 'jinhsi' && (
                <span className={`floating-element expert`}>
                  <FontAwesomeIcon icon={faAnglesUp} width="18" />
                </span>
              )}
              {showEidolon && employee.slug === 'encore' && (
                <span className={`floating-element expert`}>
                  <FontAwesomeIcon icon={faAnglesUp} width="18" />
                </span>
              )}
            </>
          )}
          {showEidolon && (
            <>
              {employee.slug === 'rover-spectro' && (
                <span className={`floating-element ww-element-tl `}>
                  <>
                    <StaticImage
                      src="../../../../images/ww/icons/element_spectro.png"
                      alt={employee.element}
                    />
                  </>
                </span>
              )}
              {employee.slug === 'rover-aero' && (
                <span className={`floating-element ww-element-tl `}>
                  <>
                    <StaticImage
                      src="../../../../images/ww/icons/element_aero.png"
                      alt={employee.element}
                    />
                  </>
                </span>
              )}
              {employee.slug === 'rover-havoc' && (
                <span className={`floating-element ww-element-tl `}>
                  <>
                    <StaticImage
                      src="../../../../images/ww/icons/element_havoc.png"
                      alt={employee.element}
                    />
                  </>
                </span>
              )}
              {employee.slug != 'rover-havoc' &&
                employee.slug != 'rover-aero' &&
                employee.slug != 'rover-spectro' && (
                  <>
                    <span className="floating-element ww-element-tl">
                      {employee.element === 'Aero' && (
                        <>
                          <StaticImage
                            src="../../../../images/ww/icons/element_aero.png"
                            alt={employee.element}
                          />
                        </>
                      )}
                      {employee.element === 'Electro' && (
                        <>
                          <StaticImage
                            src="../../../../images/ww/icons/element_electro.png"
                            alt={employee.element}
                          />
                        </>
                      )}
                      {employee.element === 'Fusion' && (
                        <>
                          <StaticImage
                            src="../../../../images/ww/icons/element_fusion.png"
                            alt={employee.element}
                          />
                        </>
                      )}
                      {employee.element === 'Glacio' && (
                        <>
                          <StaticImage
                            src="../../../../images/ww/icons/element_glacio.png"
                            alt={employee.element}
                          />
                        </>
                      )}
                      {employee.element === 'Havoc' && (
                        <>
                          <StaticImage
                            src="../../../../images/ww/icons/element_havoc.png"
                            alt={employee.element}
                          />
                        </>
                      )}
                      {employee.element === 'Spectro' && (
                        <>
                          <StaticImage
                            src="../../../../images/ww/icons/element_spectro.png"
                            alt={employee.element}
                          />
                        </>
                      )}
                    </span>
                  </>
                )}
            </>
          )}
        </div>
        {showLabel && <span className="emp-name">{employee.name}</span>}
        {showTierListchange && employee.slug === 'cantarella' && (
          <span className="floating-element tier-list-hsr new">NEW</span>
        )}
        {showTierListchange && employee.slug === 'rover-aero' && (
          <span className="floating-element tier-list-hsr new">NEW</span>
        )}
        {/* Tier list changes */}
        {showTierListchange && tier === 'toa' && (
          <>
            {employee.slug === 'taoqi' && (
              <span className="floating-element tier-list-hsr up">
                <FontAwesomeIcon icon={faArrowUp} width="18" />
              </span>
            )}
            {employee.slug === 'test' && (
              <span className="floating-element tier-list-hsr watchlist">
                <FontAwesomeIcon icon={faEye} width="18" />
              </span>
            )}
          </>
        )}
        {showTierListchange && tier === 'ww' && (
          <>
            {(employee.slug === 'brant' ||
              employee.slug === 'carlotta' ||
              employee.slug === 'changli') && (
              <span className="floating-element tier-list-hsr up">
                <FontAwesomeIcon icon={faArrowUp} width="18" />
              </span>
            )}
            {employee.slug === 'youhu' && (
              <span className="floating-element tier-list-hsr down">
                <FontAwesomeIcon icon={faArrowDown} width="18" />
              </span>
            )}
            {employee.slug === 'baizhi' && (
              <span className="floating-element tier-list-hsr watchlist">
                <FontAwesomeIcon icon={faEye} width="18" />
              </span>
            )}
          </>
        )}
        {showEidolon && tags && (
          <div className="tier-list-tags">
            {tags.split(',').map((tag, idx) => {
              return (
                <span key={idx} className={`single-tag ${tag}`}>
                  {idx === tags.split(',').length - 1 ? (
                    <>{tag}</>
                  ) : (
                    <>{tag}, </>
                  )}
                </span>
              );
            })}
          </div>
        )}
      </Link>
    </CustomPopover>
  );
};
